import React from 'react'
import { Table, Menu, ActionIcon, Box, Anchor, Text, Paper, Image } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import NoImage from '../../../assets/img/images/no-images.png'

const ActionMenu = ({ handleAction }) => {
  return (
    <Menu width={120} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableCustomMenu = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {

    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }

    const remapDataCountries = (dataCountry) => {
      const remapCountry = dataCountry.map((val, index) => {
        return (
          <Box>
            <Text fz={13} key={index} component='span'>{val.name}{index !== Object.keys(dataCountry).length - 1 ? ',' : ''}</Text>
          </Box>
        )
      })
      return remapCountry
    }


    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.menu_name}</Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={62} withBorder radius='md' style={{ cursor: 'pointer' }}>
            <Image w={60} h={60} radius='md' src={val.image_url !== null ? val.image_url : NoImage} />
          </Paper>
        </Table.Td>
        <Table.Td>{val.custom_url || '-'}</Table.Td>
        <Table.Td>{val.category || '-'}</Table.Td>
        <Table.Td tt='capitalize'>{val.menu_type || '-'}</Table.Td>
        <Table.Td>{val.countries_data.length > 0 ? remapDataCountries(val.countries_data) : '-'}</Table.Td>
        <Table.Td>{val.priority || '-'}</Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.creator !== null ? val.creator.name : 'Unknown User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.id)}>{val.updater !== null ? val.updater.name : 'Unknown User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.updated_at).format('DD/MMMM/YYYY')} - { dayjs(val.updated_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableCustomMenu